import { createSvgIconComponent } from "../utils";
export var IconCross = createSvgIconComponent({
  path: "m386.667 45.564-45.564-45.564-147.77 147.769-147.769-147.769-45.564 45.564 147.769 147.769-147.769 147.77 45.564 45.564 147.769-147.769 147.769 147.769 45.564-45.564-147.768-147.77z",
  viewBox: "0 0 386.667 386.667"
});